
export type MessagingCreateChatRoom201BasicInfoAllOfTwoType = typeof MessagingCreateChatRoom201BasicInfoAllOfTwoType[keyof typeof MessagingCreateChatRoom201BasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingCreateChatRoom201BasicInfoAllOfTwoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
